module.exports = "/packs/images/homepage/facilities/what_to_do_at_the_gym~c85659dc66d6db17ec027847b8786860.jpg";